// NOTE: below const is also using in PDF generation
// NOTE: while making changes, make sure to check pdf generation also
export const FONT_FAMILIES = [
  "Inter",
  "Abril Fatface",
  "Alex Brush",
  "Anton",
  "Balsamiq Sans",
  "Bitter",
  "Cardo",
  "Cookie",
  "Crimson Text",
  "Dancing Script",
  "EB Garamond",
  "Great Vibes",
  "Italianno",
  "Kalam",
  "Lato",
  "Libre Baskerville",
  "Lobster Two",
  "Lora",
  "Merriweather",
  "Montserrat",
  "Nunito",
  "Open Sans",
  "Oswald",
  "Pacifico",
  "Playfair Display",
  "Poppins",
  "PT Serif",
  "Raleway",
  "Righteous",
  "Roboto",
  "Rubik",
  "Source Sans Pro",
  "Ubuntu",
  "Sarabun"
];
